module.exports = __webpack_public_path__ + "static/course6-448e3db27f6c79de06dc7c5fd171952a.jpg";